/**
 * Waitlist API Client
 *
 * Public endpoint for alpha waitlist signups.
 * No authentication required.
 */

import { apiClient } from './client';

// ============================================================
// Types
// ============================================================

export interface WaitlistEntryCreate {
  name: string;
  email: string;
  role: string;
  matter_size: string;
  data_types: string[];
  pain_point: string;
}

export interface WaitlistEntryResponse {
  id: string;
  name: string;
  email: string;
  role: string;
  matter_size: string;
  data_types: string[];
  pain_point: string | null;
  created_at: string | null;
  source: string | null;
}

export interface WaitlistOptionsResponse {
  roles: Record<string, string>;
  matter_sizes: Record<string, string>;
  data_types: Record<string, string>;
}

// ============================================================
// API Functions
// ============================================================

export const waitlistApi = {
  /**
   * Join the waitlist (public, no auth)
   */
  async join(data: WaitlistEntryCreate): Promise<WaitlistEntryResponse> {
    const response = await apiClient.post<WaitlistEntryResponse>(
      '/waitlist',
      data,
      { skipAuth: true }
    );
    return response.data;
  },

  /**
   * Get form options for dropdowns (public, no auth)
   */
  async getOptions(): Promise<WaitlistOptionsResponse> {
    const response = await apiClient.get<WaitlistOptionsResponse>(
      '/waitlist/options',
      { skipAuth: true }
    );
    return response.data;
  },
};

export default waitlistApi;
